import React from 'react';
export function SolutionSection() {
  const phases = [{
    number: '01',
    title: 'Conexión Silenciosa',
    description: 'Técnica para bajar defensas en 30 seg'
  }, {
    number: '02',
    title: 'El Despertar Lógico',
    description: 'La Frase de Oro de la pág 12'
  }, {
    number: '03',
    title: 'La Rampa de Salida',
    description: 'El cierre sin conflicto ni berrinches'
  }];
  return <section className="py-12 px-4 bg-white text-deep-blue" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <div className="flex flex-col gap-6" data-id="element-109">
          {phases.map((phase, index) => <div key={index} className="flex items-center gap-6 p-6 bg-white border border-gray-100 rounded-2xl shadow-sm" data-id="element-110">
              <div className="w-16 h-16 bg-gray-50 rounded-full border-2 border-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-111">
                <span className="text-xl font-bold text-deep-blue" data-id="element-112">
                  {phase.number}
                </span>
              </div>
              <div data-id="element-113">
                <h4 className="text-xl font-bold mb-1" data-id="element-114">{phase.title}</h4>
                <p className="text-gray-600 font-medium" data-id="element-115">{phase.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}